import React from 'react';
import { IconSquareRoundedPlus } from '@tabler/icons-react';

const ActionBarAccreditationComp = (props) => {
    // console.log(props)
    return (
        <>
            <div className="d-flex align-items-center py-1">
                {/*begin::Wrapper*/}
                <div className="me-4">
                    {/*begin::Menu*/}
                    {/*begin::Button*/}
                    {
                        props.role === 'Administrator' ?
                            <a onClick={() => props.showFormAdd()} className="btn btn-sm btn-primary">
                                <IconSquareRoundedPlus stroke={2} /> Tambah Kegiatan
                            </a>
                            :
                            ''
                    }
                    {/*end::Button*/}
                    {/*end::Menu*/}
                </div>
                {/*end::Wrapper*/}
            </div>
        </>
    );
};

export default ActionBarAccreditationComp;
